
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    duration: {
      // thời gian hiển thị (ms), mặc định 3000ms = 3 giây
      type: Number,
      default: 3000,
    },
  },
  data() {
    return {
      visible: true,
    }
  },
  mounted() {
    // Tự ẩn sau thời gian `duration`
    setTimeout(() => {
      this.visible = false
    }, this.duration)
  },
}
